import { type UserRolesEnum } from "@/providers/store/api/auth/auth.enum";

interface IResolveHasAccessParams {
  allowedRoles: UserRolesEnum[];
  scope: "global" | "district";
  profileRole?: UserRolesEnum | null;
  districtRole?: UserRolesEnum | UserRolesEnum[] | null;
  districtRoleLoading?: boolean;
}

export function resolveHasAccess({
  allowedRoles,
  scope,
  profileRole,
  districtRole,
  districtRoleLoading = false,
}: IResolveHasAccessParams): boolean {
  switch (scope) {
    case "global":
      return Boolean(
        profileRole != null && allowedRoles.includes(profileRole),
      );
    case "district":
      return (
        !districtRoleLoading &&
        (Array.isArray(districtRole)
          ? districtRole.length > 0 && districtRole.some((r) => allowedRoles.includes(r))
          : districtRole != null && allowedRoles.includes(districtRole))
      );
    default:
      return false;
  }
}
